import { render } from "./CreateReferralHosPal.vue?vue&type=template&id=0107cb16&ts=true"
import script from "./CreateReferralHosPal.ts?vue&type=script&lang=ts&external"
export * from "./CreateReferralHosPal.ts?vue&type=script&lang=ts&external"

import "./CreateReferralHosPal.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__